export default "__VITE_ASSET__DBn9wP6Y__"